import { Link } from 'react-router-dom'
/**
 * Het merk uit ronde 2A: drie stukjes confetti die samen een diafragma vormen.
 *
 * De vormen zijn massief en nergens dunner dan 17% van het vlak, zodat het merk
 * op 32px in een tabblad en op 20mm gedrukt overeind blijft. Daarom staat er ook
 * geen tekst ín het beeldmerk: de wordmark is een apart onderdeel dat je erbij
 * zet als er plaats voor is.
 */

/** Het donkere stukje. Elders `currentColor`, zodat het merk meekleurt. */
const inkPiece = 'M-29 -34 h58 a8.5 8.5 0 0 1 0 17 h-58 a8.5 8.5 0 0 1 0 -17 z'

export function ConfettiMark({
  size = 32,
  tone = 'kleur',
  className,
}: {
  size?: number
  /**
   * `kleur` is de standaard. `effen` tekent alle drie de stukjes in
   * `currentColor` — voor een gedrukt kaartje, een gegraveerde variant, of
   * ergens waar het merk klein en op een onrustige achtergrond staat.
   */
  tone?: 'kleur' | 'effen'
  className?: string
}) {
  const coral = tone === 'effen' ? 'currentColor' : '#E0603C'
  const ocher = tone === 'effen' ? 'currentColor' : '#E9A63C'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label="Confetti"
      className={className}
    >
      <g transform="translate(50 50)">
        <path d={inkPiece} fill="currentColor" />
        <path d={inkPiece} fill={coral} transform="rotate(120)" />
        <path d={inkPiece} fill={ocher} transform="rotate(240)" />
      </g>
    </svg>
  )
}

/**
 * De naam in Bricolage Grotesque. Staat los van het beeldmerk omdat de twee
 * niet altijd samen voorkomen: in een smalle balk past alleen het merk.
 */
export function ConfettiWordmark({ className = 'text-[26px]' }: { className?: string }) {
  return <span className={`font-brand font-bold tracking-[-0.02em] ${className}`}>Confetti</span>
}

/**
 * Merk en naam naast elkaar, zoals op het logovel.
 *
 * Standaard een link naar huis: ben je ingelogd dan is dat "Mijn events", en
 * anders het aanmeldscherm. Een logo linksboven dat nergens heen gaat is een
 * dode plek waar iedereen toch op klikt.
 */
export function Logo({
  size = 30,
  className,
  to = '/beheer',
}: {
  size?: number
  className?: string

  /** Op `null` is het geen link. Voor het aanmeldscherm zelf. */
  to?: string | null
}) {
  const inside = (
    <>
      <ConfettiMark size={size} />
      <ConfettiWordmark className={size >= 30 ? 'text-[26px]' : 'text-[21px]'} />
    </>
  )

  const shell = `inline-flex items-center gap-2.5 ${className ?? ''}`

  if (to === null) {
    return <span className={shell}>{inside}</span>
  }

  return (
    <Link to={to} aria-label="Naar Confetti" className={`${shell} transition hover:opacity-80`}>
      {inside}
    </Link>
  )
}
